/* Auto-generated from page-tabs-template.ejs */
const template = function anonymous(data, escapeFn, include, rethrow
) {
"use strict";
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<ul>\n    <% data.pageNames.forEach((page, index) => { %>\n    <li data-page=\"<%- index.toString() %>\" class=\"<%- (index === 0) ? 'is-active' : '' %>\">\n        <a>\n            <span><%- page %></span>\n        </a>\n    </li>\n    <% }); %>\n</ul>\n\n"
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
    ; __append("<ul>\n    ")
    ; __line = 2
    ;  data.pageNames.forEach((page, index) => { 
    ; __append("\n    <li data-page=\"")
    ; __line = 3
    ; __append( index.toString() )
    ; __append("\" class=\"")
    ; __append( (index === 0) ? 'is-active' : '' )
    ; __append("\">\n        <a>\n            <span>")
    ; __line = 5
    ; __append( page )
    ; __append("</span>\n        </a>\n    </li>\n    ")
    ; __line = 8
    ;  }); 
    ; __append("\n</ul>\n\n")
    ; __line = 11
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

};
export default template;
